export const FETCH_ALL = "products_List";

export const FETCH = "products_FindById";

export const CREATE = "products_CreateOne";

export const EDIT = "products_UpdateById";

export const DELETE = "products_RemoveManyByIds";
